// import store from "ceres/app/store/index.js";
import Vue from "vue";

Vue.directive("render-category", {

    bind(el, binding)
    {

        el.dataset.categoryId = binding.value.id;
        el.dataset.categoryType = binding.value.type;

        el.onclick = event =>
        {

            //event.preventDefault();
            //
            // const currentCategoryType = store.state.navigation.currentCategory ? store.state.navigation.currentCategory.type : null;
            //
            // let nextParentCategory = store.state.navigation.tree.find(category =>
            // {
            //     return category.children ? category.children.some(child =>
            //     {
            //         return child.id === parseInt(el.dataset.categoryId);
            //     }) : category.id === parseInt(el.dataset.categoryId);
            // });
            //
            // if (typeof nextParentCategory === "undefined")
            // {
            //     nextParentCategory = store.state.navigation.tree.find(category =>
            //     {
            //         return category.id === parseInt(el.dataset.categoryId);
            //     });
            // }
            //
            // if (nextParentCategory.id === 545)
            // {
            //     $(".shop-nav__logo").attr("src", $(".shop-nav__logo").data("maria"));
            //     $(".shop-nav__logo").parent().attr("href", "/vive-maria");
            // }
            // else if (nextParentCategory.id === 417)
            // {
            //     $(".shop-nav__logo").attr("src", $(".shop-nav__logo").data("deluxe"));
            //     $(".shop-nav__logo").parent().attr("href", "/pussy-deluxe");
            // }
            // else
            // {
            //     $(".shop-nav__logo").attr("src", $(".shop-nav__logo").data("potsdam"));
            //     $(".shop-nav__logo").parent().attr("href", "/");
            // }
            //
            // if (!App.isCategoryView || currentCategoryType !== el.dataset.categoryType)
            // {
            //
            //     store.dispatch("selectCategory", {categoryId: parseInt(el.dataset.categoryId), withReload: true});
            //
            //     // show megamenu on touch lg devices
            //     if (
            //         document.body.classList.contains("touch") &&
            //         store.state.navigation.currentCategory.level > 1 &&
            //         $(document).outerWidth() >= 992
            //     )
            //     {
            //         window.open(store.state.navigation.currentCategory.url, "_self");
            //     }
            //     else if (
            //         !document.body.classList.contains("touch") ||
            //         $(document).outerWidth() < 992 ||
            //         typeof el.dataset.toAll !== "undefined"
            //     )
            //     {
            //         window.open(store.state.navigation.currentCategory.url, "_self");
            //     }
            //
            // }
            // else
            // {
            //     store.dispatch("selectCategory", {categoryId: parseInt(el.dataset.categoryId), withReload: true});
            //
            //     // show megamenu on touch lg devices AND reload
            //     if (
            //         document.body.classList.contains("touch") &&
            //         (store.state.navigation.currentCategory.level > 1 || typeof el.dataset.toAll !== "undefined") &&
            //         $(document).outerWidth() >= 992
            //     )
            //     {
            //         store.dispatch("selectCategory", {categoryId: parseInt(el.dataset.categoryId)});
            //     }
            //     else if (!(document.body.classList.contains("touch") && $(document).outerWidth() >= 992))
            //     {
            //         store.dispatch("selectCategory", {categoryId: parseInt(el.dataset.categoryId)});
            //     }
            //
            //     $("html, body").animate({scrollTop: 0}, 500);
            // }
        };
    },

    update(el, binding)
    {
        el.dataset.categoryId = binding.value.id;
        el.dataset.categoryType = binding.value.type;
    }
});
